// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import http from './utils/http'

import '../static/css/reset.css';
import '../theme/index.css'
import '../src/assets/aliIcon/iconfont.css'


// import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(VueAxios,axios);

Vue.config.productionTip = false
let locale = localStorage.getItem('lang');

const i18n = new VueI18n({
    locale: locale==undefined?'zh-CN':locale,    // 语言标识
    // this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh-CN': require('./languages/lang/zh'),   // 中文语言包
      'en': require('./languages/lang/zh')    // 英文语言包
    },
      silentTranslationWarn: true,
})
Vue.i18n = i18n

// 判断是否是登录状态
router.beforeEach((to, from, next) => {
  let toRouter = {
    name:to.name
  }
  let fromRouter = {
    name:from.name
  }
  //路由发生变化修改页面title
  if (to.meta.title) {  
    document.title = to.meta.title;
  }
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  if(to.matched.some(m => m.meta.requireAuth)) {
    // console.log(localStorage.getItem('token'))
    if(localStorage.getItem('TOKEN')!=null) {
      next()
    } else{
        next({
          path: '/'    
        })　　　　　
    }　　
  } else {　　　　　　
    next()　　
  }
});

router.afterEach((to,from,next)=>{
　window,scrollTo(0,0)
})



/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js